import { z } from 'zod';

export const MaintenanceSourceSchema = z.enum(['THIS_SHOP', 'OTHER_SHOP', 'MANUAL']);

export type MaintenanceSource = z.infer<typeof MaintenanceSourceSchema>;

export const RecordVehicleMaintenanceBodySchema = z.object({
  maintenanceTypeId: z.uuid(),
  performedAtKm: z.number().nonnegative(),
  performedAt: z.iso.date().optional(),
  source: MaintenanceSourceSchema,
  reason: z.string().trim().optional(),
  notes: z.string().trim().optional(),
});

export type RecordVehicleMaintenanceBody = z.infer<typeof RecordVehicleMaintenanceBodySchema>;

export const RecordVehicleMaintenanceResponseSchema = z.object({
  recordId: z.uuid(),
});

export type RecordVehicleMaintenanceResponse = z.infer<
  typeof RecordVehicleMaintenanceResponseSchema
>;

export const VehicleMaintenanceHistoryItemSchema = z.object({
  id: z.uuid(),
  maintenanceTypeId: z.uuid(),
  performedAtKm: z.number().nonnegative(),
  performedAt: z.iso.date().nullable(),
  source: MaintenanceSourceSchema,
  reason: z.string().nullable(),
  notes: z.string().nullable(),
  serviceOrderId: z.uuid().nullable(),
  createdByUserId: z.uuid(),
  createdAt: z.iso.datetime(),
});

export type VehicleMaintenanceHistoryItem = z.infer<typeof VehicleMaintenanceHistoryItemSchema>;

export const ListVehicleMaintenanceHistoryResponseSchema = z.object({
  items: z.array(VehicleMaintenanceHistoryItemSchema),
});

export type ListVehicleMaintenanceHistoryResponse = z.infer<
  typeof ListVehicleMaintenanceHistoryResponseSchema
>;

export const MaintenanceDueStatusSchema = z.enum(['OVERDUE', 'DUE_SOON', 'OK', 'UNKNOWN']);

export type MaintenanceDueStatus = z.infer<typeof MaintenanceDueStatusSchema>;

export const VehicleMaintenanceStatusItemSchema = z.object({
  maintenanceTypeId: z.uuid(),
  slug: z.string(),
  name: z.string(),
  status: MaintenanceDueStatusSchema,
  lastPerformedAtKm: z.number().nullable(),
  lastPerformedAt: z.iso.date().nullable(),
  dueAtKm: z.number().nullable(),
  dueAtDate: z.iso.date().nullable(),
});

export type VehicleMaintenanceStatusItem = z.infer<typeof VehicleMaintenanceStatusItemSchema>;

export const GetVehicleMaintenanceStatusResponseSchema = z.object({
  items: z.array(VehicleMaintenanceStatusItemSchema),
});

export type GetVehicleMaintenanceStatusResponse = z.infer<
  typeof GetVehicleMaintenanceStatusResponseSchema
>;

export const VehicleMaintenanceTypeSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
});

export type VehicleMaintenanceType = z.infer<typeof VehicleMaintenanceTypeSchema>;

export const ListVehicleMaintenanceTypesResponseSchema = z.object({
  items: z.array(VehicleMaintenanceTypeSchema),
});

export type ListVehicleMaintenanceTypesResponse = z.infer<
  typeof ListVehicleMaintenanceTypesResponseSchema
>;

export const VehicleModelMaintenanceScheduleSchema = z.object({
  maintenanceTypeId: z.uuid(),
  maintenanceTypeSlug: z.string(),
  maintenanceTypeName: z.string(),
  intervalKm: z.number().nullable(),
  intervalDays: z.number().int().nullable(),
});

export type VehicleModelMaintenanceSchedule = z.infer<typeof VehicleModelMaintenanceScheduleSchema>;

export const ListModelMaintenanceSchedulesResponseSchema = z.object({
  items: z.array(VehicleModelMaintenanceScheduleSchema),
});

export type ListModelMaintenanceSchedulesResponse = z.infer<
  typeof ListModelMaintenanceSchedulesResponseSchema
>;
